export const uploadsFolder =
  process.env.UPLOADS_FOLDER || "/public-upload-folder";
